export const COMMON_PROPERTY_NAMES = {
  NAME: 'name',
  DISPLAY_NAME: 'displayName',
  LOCALIZATION_KEY: 'localizationKey',
  DESCRIPTION: 'description',
} as const
export const DYNAMIC_PROPERTY_NAMES = {
  REQUIRED: 'required',
  REQUIRED_EXP: 'requiredExp',
  LABEL_EXP: 'labelExp',
  VALUE_EXP: 'valueExp',
  READ_ONLY: 'readOnly',
  READ_ONLY_EXP: 'readOnlyExp',
  HIDDEN: 'hidden',
  HIDDEN_EXP: 'hiddenExp',
  LIST_EXP: 'listExp',
  SAVE_EXP: 'saveExpression',
  FILTER_EXP: 'filterExp',
  COLLAPSED_EXP: 'collapsedExp',
  PROPERTY_OVERRIDE: 'propertyOverride',
} as const
export const FORM_PROPERTY_NAMES = {
  ID: 'id',
  FORM_NAME: 'formName',
  DESCRIPTION: COMMON_PROPERTY_NAMES.DESCRIPTION,
  META: 'meta',
  SYSTEM: 'idSubsystem',
  MAIN_TABLE: 'mainTable',
  URL: 'url',
  TAGS: 'tags',
  HIDDEN_EXP: DYNAMIC_PROPERTY_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_NAMES.READ_ONLY_EXP,
  SAVE_EXP: DYNAMIC_PROPERTY_NAMES.SAVE_EXP,
  MENU_ASSIGNER: 'menuAssigner',
} as const
export const PAGE_PROPERTY_NAMES = {
  NAME: COMMON_PROPERTY_NAMES.NAME,
  DESCRIPTION: 'expDescrPage',
  LABEL_EXP: DYNAMIC_PROPERTY_NAMES.LABEL_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_NAMES.READ_ONLY_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_NAMES.COLLAPSED_EXP,
}
export const GROUP_PROPERTY_NAMES = {
  NAME: COMMON_PROPERTY_NAMES.NAME,
  DESCRIPTION: 'expDescrGroup',
  LABEL_EXP: DYNAMIC_PROPERTY_NAMES.LABEL_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_NAMES.HIDDEN_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_NAMES.READ_ONLY_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_NAMES.COLLAPSED_EXP,
  INVISIBLE_BORDER: 'invisibleBorder',
} as const
export const FIELD_PROPERTY_NAMES = {
  NAME: COMMON_PROPERTY_NAMES.NAME,
  DROPDOWN_NAME: 'dropdownName',
  DESCRIPTION: COMMON_PROPERTY_NAMES.DESCRIPTION,
  MULTISELECT_NAME: 'multiselectName',
  DISPLAY_NAME: COMMON_PROPERTY_NAMES.DISPLAY_NAME,
  LOCALIZATION_KEY: COMMON_PROPERTY_NAMES.LOCALIZATION_KEY,
  PLACEHOLDER: 'placeholderKey',
  DATE_PICKER_VIEW: 'datePickerView',
  READ_ONLY: 'readOnly',
  LINK_TYPE: 'linkType',
  UNDERLINE: 'underline',
  PREFIX_ICON: 'prefixIcon',
  THOUSAND_SEPARATED: 'thousandSeparated',
  TAGGABLE: 'taggable',
  CAPTCHA_TYPE: 'captchaType',
  REF_TABLE: 'refTable',
  REL_FORM_ID: 'relFormId',
  REL_FIELD: 'relField',
  SUB_FORM_PROPS: 'subFormProps',
  SUB_ID_FORM: 'subIdForm',
  SUB_COLUMN_NAME_MAIN: 'subColumnNameMain',
  SUB_COLUMN_NAME_SUB: 'subColumnNameSub',
  SUB_MIN_NUMBER_OF_REC: 'subMinNumberOfRec',
  SUB_MAX_NUMBER_OF_REC: 'subMaxNumberOfRec',
  SUB_REC_EXTENDABLE: 'subRecExtendable',
  SUB_REC_DELETABLE: 'subRecDeletable',
  SUBFORM_PURE: 'subformPure',
  HIDDEN: 'hidden',
  SAVE_DATA: 'saveData',
  UNIQUE: 'unique',
  NO_CLONING: 'noCloning',
  MULTISELECT: 'multiselect',
  CREATE_NEW_ELEMENT: 'createNewElement',
  TEMPLATE_ITEM: 'templateItem',
  FORMATTED_TEXT: 'formattedText',
  OPTIONS_JSON: 'optionsJson',
  IS_TECHNICAL: 'isTechnical',
  IS_STATIC: 'isStatic',
  HTML_VALUE: 'htmlValue',
  DROPDOWN_ONLY_ONE: 'dropdownOnlyOne',
  FORM_DATA_PROCESS_ID: 'formDataProcessId',
  MAP_DATA_ENTITY: 'mapDataEntity',
  MAP_PROPERTIES: 'mapProperties',
  MAP_DEFAULT_ADDRESS_EXP: 'mapDefaultAddressExp',
  EXPRESSION: 'expression',
  VALUE_IS_DEFAULT: 'valueIsDefault',
  VALUE_FROM_PARAM: 'valueFromParam',
  PROPERTY_OVERRIDE: 'propertyOverride',
  CALENDAR_OPTIONS: 'calendarOptions',

  TIME_FORMAT: 'timeFormat',
  DIRECT_INPUT_ENTRY: 'directInputEntry',
  IS_TIME_SELECT: 'isTimeSelect',
  START_TIME: 'startTime',
  END_TIME: 'endTime',
  TIME_STEP: 'timeStep',
  MIN: 'min',
  MAX: 'max',
  DECIMAL: 'decimal',
  PREFIX: 'prefix',
  SUFFIX: 'suffix',
  MIN_LENGTH: 'minlength',
  MAX_LENGTH: 'maxlength',
  MAX_FILE_SIZE: 'maxFileSize',
  FILE_TYPES: 'fileTypes',
  PATTERN: 'pattern',
  MIN_EXP: 'minExp',
  MAX_EXP: 'maxExp',
  REQUIRED: 'required',
  ROWS: 'rows',

  REQUIRED_EXP: DYNAMIC_PROPERTY_NAMES.REQUIRED_EXP,
  LABEL_EXP: DYNAMIC_PROPERTY_NAMES.LABEL_EXP,
  VALUE_EXP: DYNAMIC_PROPERTY_NAMES.VALUE_EXP,
  READ_ONLY_EXP: DYNAMIC_PROPERTY_NAMES.READ_ONLY_EXP,
  HIDDEN_EXP: DYNAMIC_PROPERTY_NAMES.HIDDEN_EXP,
  LIST_EXP: DYNAMIC_PROPERTY_NAMES.LIST_EXP,
  SAVE_EXP: DYNAMIC_PROPERTY_NAMES.SAVE_EXP,
  FILTER_EXP: DYNAMIC_PROPERTY_NAMES.FILTER_EXP,
  COLLAPSED_EXP: DYNAMIC_PROPERTY_NAMES.COLLAPSED_EXP,

  LIST_SOURCE: 'listSource',
  LIST_SOURCE_TYPE: 'listSourceType',
  SQL_CHOSEN_SOURCE: 'sqlChosenSource',
  LIST_SOURCE_FORM_ID: 'listSourceFormId',
  LIST_SOURCE_FIELD: 'listSourceField',

  TIME_SELECT_FORM: 'timeSelectForm',
} as const
export const VALIDATION_PROPERTY_NAMES = {
  ADD_NEW_VALIDATION: 'addNewOriginal',
  ADD_NEW_LIGHT_VALIDATION: 'addNewLight',
} as const
export const DYNAMIC_PROPERTIES = Object.values(DYNAMIC_PROPERTY_NAMES)
export const FORM_PROPERTIES = Object.values(FORM_PROPERTY_NAMES)
export const PAGE_PROPERTIES = Object.values(PAGE_PROPERTY_NAMES)
export const GROUP_PROPERTIES = Object.values(GROUP_PROPERTY_NAMES)
export const FIELD_PROPERTIES = Object.values(FIELD_PROPERTY_NAMES)
